import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';
import { CustomSnackbarComponent } from '../../shared/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class ActionGridService {
  
  constructor(
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {}

  filetypeUpdateQuery(data: any) {
    return this.apiService.post("kpi/update-payemnet-file-type", data);
  }
  
  filetypeGetQuery(data: any) {
    return this.apiService.post("kpi/get-payemnet-file-types", data);
  }
  
  filetypeDeleteQuery(data: any) {
    return this.apiService.post("kpi/delete-payemnet-file-type", data);
  }

   customSnackBars(message:any, action:any, color:any) {
      this._snackBar.openFromComponent(CustomSnackbarComponent, {
        duration: 3000,
        data: {
          action: action,
          message: message
        },
        panelClass: ['api-' + color + '-snackbar']
      })
    }
}
